import React from 'react'
import "./ContributionSection.scss";

import { useDraggableSheet } from '../../../helpers/hooks';
import Icon from '../Icon/Icon';

function ContributionSuccess({ onClose }) {

    const {
        sheetStyle,
        overlayHandlers,
    } = useDraggableSheet({ onClose });

    return (
        <div className="contribution-section" {...overlayHandlers}>
            <div
                className={`sheet`}
                style={sheetStyle}
                onClick={(e) => e.stopPropagation()}
            >
                <div className="pull-bar" />

                <div className="contribution-box px-24 mb-24">
                    <div className="success-box d-flex f-column py-48 aic jcc">
                        <div className="icon-wrapper mb-24">
                            <Icon alias="thanks-for-contribution" width={160} height={160} color="#ff0000" />
                        </div>
                        <h3 className="title mb-16">You just made a creator's day</h3>
                        <p className="description mb-32 mt-0 text-center">Your support means more than you think.
                            Every contribution helps bring bold ideas to life — and you're now part of that journey.</p>
                    </div>
                </div>

                <div className="submit-box d-flex f-column px-16 py-24">
                    <button
                        onClick={onClose}
                        type="button"
                        className="btn red-outline-btn btn-full d-flex aic jcc fw-bold mb-16 py-24 "
                    >
                        <span>Done</span>
                    </button>
                </div>
            </div>
        </div>
    )
}

export default ContributionSuccess